<template>
<div>
    <b-modal id="matterMonitoringSurveillanceFormModal" ref="matterMonitoringSurveillanceFormModal" centered size="lg" no-close-on-backdrop :title="$t('matter.matter_monitoring_surveillance')" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
        <b-card>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.law_matter_subject') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.law_authority_platform') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawAuthorityPlatformSelect" value-field="id" text-field="name" :options="lawAuthorityPlatformOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.law_product_category') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProductCategorySelect" value-field="id" text-field="name" :options="lawProductCategoryOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.law_counter_party') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.law_type_of_violation') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawTypeOfViolationSelect" value-field="id" text-field="name" :options="lawTypeOfViolationOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.stock_reference') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="stockReference" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.monitoring_holder') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="monitoringHolder" maxlength="250" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.vendor_name') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="vendorName" maxlength="250" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.product_name') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="productName" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.web_site') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="webSite" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterMonitoringSurveillance.physical_store_address') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="physicalStoreAddress" maxlength="250" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawMatterSubjectOptions: [],
            lawMatterSubjectSelect: 0,
            lawAuthorityPlatformOptions: [],
            lawAuthorityPlatformSelect: 0,
            lawProductCategoryOptions: [],
            lawProductCategorySelect: 0,
            lawCounterPartyOptions: [],
            lawCounterPartySelect: 0,
            lawTypeOfViolationOptions: [],
            lawTypeOfViolationSelect: 0,
            monitoringHolder: '',
            vendorName: '',
            physicalStoreAddress: '',
            webSite: '',
            productName: '',
            stockReference: '',
        }
    },
    methods: {
        showMonitoringSurveillance(id, lawMatterId) {
            this.$refs['matterMonitoringSurveillanceFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterMonitoringSurveillance'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.lawMatterSubjectOptions = response.data.lawMatterSubjectList
                    if (this.lawMatterSubjectOptions != null) {
                        this.lawMatterSubjectOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawAuthorityPlatformOptions = response.data.lawAuthorityPlatformList
                    if (this.lawAuthorityPlatformOptions != null) {
                        this.lawAuthorityPlatformOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawProductCategoryOptions = response.data.lawProductCategoryList
                    if (this.lawProductCategoryOptions != null) {
                        this.lawProductCategoryOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawCounterPartyOptions = response.data.lawSellersList
                    if (this.lawCounterPartyOptions != null) {
                        this.lawCounterPartyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawTypeOfViolationOptions = response.data.lawTypeOfViolationList
                    if (this.lawTypeOfViolationOptions != null) {
                        this.lawTypeOfViolationOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterSubjectSelect = response.data.lawMatterMonitoringSurveillance.lawMatterSubjectId
                    this.lawAuthorityPlatformSelect = response.data.lawMatterMonitoringSurveillance.lawAuthorityPlatformId
                    this.lawProductCategorySelect = response.data.lawMatterMonitoringSurveillance.lawProductCategoryId
                    this.lawCounterPartySelect = response.data.lawMatterMonitoringSurveillance.lawCounterPartyId
                    this.lawTypeOfViolationSelect = response.data.lawMatterMonitoringSurveillance.lawTypeOfViolationId
                    this.monitoringHolder = response.data.lawMatterMonitoringSurveillance.monitoringHolder
                    this.vendorName = response.data.lawMatterMonitoringSurveillance.vendorName
                    this.physicalStoreAddress = response.data.lawMatterMonitoringSurveillance.physicalStoreAddress
                    this.webSite = response.data.lawMatterMonitoringSurveillance.webSite
                    this.productName = response.data.lawMatterMonitoringSurveillance.productName
                    this.stockReference = response.data.lawMatterMonitoringSurveillance.stockReference
                } else {
                    this.$bvModal.hide('matterMonitoringSurveillanceFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async addOrUpdate() {
            const lawMatterMonitoringSurveillanceData = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawMatterSubjectId: this.lawMatterSubjectSelect,
                lawAuthorityPlatformId: this.lawAuthorityPlatformSelect,
                lawProductCategoryId: this.lawProductCategorySelect,
                lawCounterPartyId: this.lawCounterPartySelect,
                lawTypeOfViolationId: this.lawTypeOfViolationSelect,
                monitoringHolder: this.monitoringHolder,
                vendorName: this.vendorName,
                physicalStoreAddress: this.physicalStoreAddress,
                webSite: this.webSite,
                productName: this.productName,
                stockReference: this.stockReference,
            }
            const controller = {
                name: 'LawMatterMonitoringSurveillance'
            }
            const payload = {
                data: lawMatterMonitoringSurveillanceData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if (!this.id) {
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(15, this.id, this.lawMatterId, this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterMonitoringSurveillanceFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
